/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function initProductAlertModals(root = document) {
    root.querySelectorAll('[data-section-type="product"]').forEach((productSection) => {
      if (productSection.dataset.alertBound === 'true') {
        return;
      }

      const modal = document.querySelector('[data-product-alert-modal]');

      if (!modal) {
        return;
      }

      const form = modal.querySelector('[data-product-alert-form]');
      const success = form && form.dataset.productAlertSuccess
        ? document.getElementById(form.dataset.productAlertSuccess)
        : null;
      const country = modal.querySelector('[data-product-alert-country]');
      const phone = modal.querySelector('[data-product-alert-phone]');
      const phoneOutput = modal.querySelector('[data-product-alert-phone-output]');
      const closers = modal.querySelectorAll('[data-product-alert-close]');

      function syncPhone() {
        if (!country || !phone || !phoneOutput) {
          return;
        }

        const number = (phone.value || '').replace(/[^\d]/g, '');
        phoneOutput.value = number ? `${country.value || ''}${number}` : '';
      }

      function openModal(event) {
        if (event) {
          event.preventDefault();
        }

        if (form) {
          form.hidden = false;
        }

        if (success) {
          success.hidden = true;
        }

        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');

        if (phone) {
          window.setTimeout(() => phone.focus(), 20);
        }
      }

      function closeModal() {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
      }

      function setSoldOutState(variant) {
        const button = productSection.querySelector('.ProductForm__AddToCart');
        const notice = productSection.querySelector('[data-product-sold-out-notice]');

        if (!button) {
          return;
        }

        const isUnavailable = !variant;
        const isSoldOut = variant && variant.available === false;

        if (isSoldOut) {
          if (notice) {
            notice.hidden = false;
          }

          button.type = 'button';
          button.disabled = false;
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
          button.removeAttribute('data-action');
          button.setAttribute('data-product-alert-open', '');
          button.setAttribute('aria-haspopup', 'dialog');
          button.classList.remove('Button--primary');
          button.classList.add('Button--secondary');
          button.innerHTML = '<span>GET ALERTS</span>';
          return;
        }

        if (notice) {
          notice.hidden = true;
        }

        button.removeAttribute('data-product-alert-open');
        button.removeAttribute('aria-haspopup');

        if (isUnavailable) {
          return;
        }

        button.type = 'submit';
      }

      productSection.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-product-alert-open]');

        if (trigger) {
          openModal(event);
        }
      });

      productSection.addEventListener('variant:changed', (event) => {
        window.setTimeout(() => setSoldOutState(event.detail.variant), 0);
      });

      closers.forEach((closer) => {
        closer.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.hidden === false) {
          closeModal();
        }
      });

      if (country) {
        country.addEventListener('change', syncPhone);
      }

      if (phone) {
        phone.addEventListener('input', syncPhone);
      }

      if (form) {
        form.addEventListener('submit', () => {
          syncPhone();

          if (success) {
            success.hidden = false;
            form.hidden = true;
          }
        });
      }

      syncPhone();
      productSection.dataset.alertBound = 'true';
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductAlertModals(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductAlertModals(), { once: true });
  } else {
    initProductAlertModals();
  }
})();

(function () {
  const isiOS =
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

  const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  if (!isiOS || !isTouchDevice) {
    return;
  }

  let lastTouchEndAt = 0;

  document.addEventListener('touchend', (event) => {
    if (event.touches.length > 0) {
      return;
    }

    const target = event.target;

    if (target && target.closest('input, textarea, select, [contenteditable="true"]')) {
      lastTouchEndAt = Date.now();
      return;
    }

    const now = Date.now();

    if (now - lastTouchEndAt <= 320) {
      event.preventDefault();
    }

    lastTouchEndAt = now;
  }, { passive: false });
})();
